export default __webpack_public_path__ + "static/media/slider-cai-3.9625def5.jpg";